module.exports = __webpack_public_path__ + "static/media/TW-inside-cover-tablet-738x57@2x.df355100.webp";